import { ParentProps, Show, createMemo } from 'solid-js'
import styles from './st-loader.module.css'
import Icon from '../st-icon/st-icon';
import Flexbox from "../st-flexbox/st-flexbox";

export class LoaderProps {
    size?: 'small' | 'medium' | 'large' = 'small';
    label?: string =  'Loading...'
}

const sizes = {
    'small': 18,
    'medium': 36,
    'large': 64
};

export default function Loader(props: LoaderProps) {
    const direction = createMemo(() => {
        if (props.size === 'small') {
            return 'horizontal';
        }
        return 'vertical';
    });

    const size = createMemo(() => sizes[props.size ?? 'small']);

    return (
        <Flexbox padded middle dir={direction()} class={styles.loader} >
            <Flexbox.Item>
                <Icon src="fa-solid fa-spinner" spin={true} size={size()} />
            </Flexbox.Item>
            <Show when={props.label}>
                <Flexbox.Item class={styles.label} >
                    {props.label}
                </Flexbox.Item>
            </Show>
        </Flexbox>
    );
}

Loader.defaultProps = new LoaderProps();